export const eAristoTopicQuestionType = {
    VideoQuestions: 0,
    PresentationQuestions: 1,
    TopicQuestions: 2,
};